var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1137.6 687.6c-15.602-104.4-104.4-178.8-205.2-183.6 25.199-93.602 86.398-130.8 160.8-152.4 7.1992-2.3984 6-9.6016 6-9.6016l-12-74.398s-1.1992-6-10.801-4.8008c-256.8 28.801-430.8 224.4-398.4 462 29.996 164.4 158.39 228 277.2 211.2 118.8-19.199 200.4-129.6 182.4-248.4zm-819.6-183.6c24-93.602 87.602-130.8 160.8-152.4 7.1992-2.3984 6-9.6016 6-9.6016l-10.801-74.398s-1.1992-6-10.801-4.8008c-256.8 27.598-429.6 223.2-399.6 460.8 31.199 165.6 160.8 229.2 278.4 212.4 118.8-19.199 200.4-129.6 181.2-248.4-15.598-105.6-103.2-180-205.2-183.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.fb5d0721402e4442587f34d07a06fc6b.svg";
export { ForwardRef as ReactComponent };